import { styled, Box, Pagination as MUIPagination } from "@mui/material";

export const PaginationWrapper = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "1vw 2vw",
});
export const Pagination = styled(MUIPagination)({
  " &  li:first-child, & li:last-child": {
    "& button": {
      color: "#C4CDD5",
    },
  },

  "& li": {
    "& button": {
      border: "1px solid #EEEEEE",
      color: "#123051",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      fontFamily: "DM Sans",
      background: "transparent",
    },
  },

  "& .Mui-disabled": {
    background: "#919EAB",
    opacity: 0.5,
  },
  "& .Mui-selected": {
    border: "1px solid #123051",
    background: "transparent !important",
  },
});
